import { render, staticRenderFns } from "./EducationalScheduleTimeDelete.vue?vue&type=template&id=1012d454&"
import script from "./EducationalScheduleTimeDelete.vue?vue&type=script&lang=js&"
export * from "./EducationalScheduleTimeDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports